import { Head } from "@inertiajs/react";
import { type ReactNode } from "react";

interface PageTitleProps {
  title: string;
  subtitle?: string;
  /** Rendered inline after the subtitle (e.g. contextual links). */
  subtitleExtra?: ReactNode;
  /** Override the browser tab title; defaults to `title`. */
  tabTitle?: string;
}

export default function PageTitle({ title, subtitle, subtitleExtra, tabTitle }: PageTitleProps) {
  return (
    <div>
      <Head title={tabTitle ?? title} />
      <h1 style={{ fontSize: 16, lineHeight: "24px", fontWeight: 700, color: "var(--foreground)", margin: 0, letterSpacing: "-0.02em" }}>{title}</h1>
      {subtitle && (
        <div style={{ fontSize: 12, color: "var(--muted-foreground)", marginTop: 1 }}>
          {subtitle}
          {subtitleExtra && <span style={{ marginLeft: 10 }}>{subtitleExtra}</span>}
        </div>
      )}
    </div>
  );
}
